import { render } from "./SelectWondedsTypes.vue?vue&type=template&id=6c0d48b3"
import script from "./SelectWondedsTypes.vue?vue&type=script&lang=js"
export * from "./SelectWondedsTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__